import { render, staticRenderFns } from "./ProjectVacancies.vue?vue&type=template&id=e04a6c8c&scoped=true"
import script from "./ProjectVacancies.vue?vue&type=script&lang=js"
export * from "./ProjectVacancies.vue?vue&type=script&lang=js"
import style0 from "./ProjectVacancies.vue?vue&type=style&index=0&id=e04a6c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04a6c8c",
  null
  
)

export default component.exports